/**
 * Instancia compartida de axios con interceptores de request (token JWT) y response (401/403 → logout).
 */
import axios from "axios";
import { message } from "antd";
import checkTimeStampLoggedUser from "utils/validation/checkTimestampLoggedUser";
import { jwtDecode } from "jwt-decode";

// 🔹 Placeholder de logout, se va a inyectar desde AuthProvider
let logoutFunc = () => {};

// Permite inyectar la función logout desde el contexto
export const setLogoutFunc = (fn) => {
  logoutFunc = fn;
};

// Instancia Axios
const axiosController = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { "Content-Type": "application/json" },
});

let hasShownExpiredMessage = false;

// 🔹 Función que muestra mensaje y luego hace logout con delay
const logoutWithDelay = () => {
  if (logoutFunc) {
    message.error("Tu sesión ha expirado. Serás redirigido al login.");
    setTimeout(() => {
      logoutFunc();
    }, 2000);
  }
};

// Interceptor de request
axiosController.interceptors.request.use(
  (config) => {
    const token = config.headers?.Authorization?.split(" ")[1];
    if (token && !checkTimeStampLoggedUser(jwtDecode(token).exp)) {
      if (!hasShownExpiredMessage) {
        hasShownExpiredMessage = true;
        logoutWithDelay();
      }
      return Promise.reject(new Error("Token expirado"));
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor de response
axiosController.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    if ((status === 401 || status === 403) && !hasShownExpiredMessage) {
      hasShownExpiredMessage = true;
      logoutWithDelay();
    }
    return Promise.reject(error);
  }
);

export default axiosController;
